module.exports = "a:hover {\n  text-decoration: underline;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/manage-applications/generate-payment-link/generate-payment-link.component.css
// module id = ./src/app/manage-applications/generate-payment-link/generate-payment-link.component.css
// module chunks = main